export class OrganisationTypeReferenceModel {
    public organisationTypeCode: string;
    public organisationTypeName: string;
    public primaryFlag: boolean = null;
    public sortSequence: number;
}